import {
    MDBAlert,
    MDBBreadcrumb,
    MDBBreadcrumbItem,
    MDBBtn,
    MDBCol,
    MDBRow,
    MDBScrollspy,
    MDBScrollspyLink,
    MDBSpinner,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { editPhoneNumberDetails, getSpecificPhoneDetails } from "../../../apiclients/streamsapi_bridge";
import Body from "../../../components/body/BodyPage";
import MainLinks from "../../../components/navlinks/MainLinks";
import SaveChanges from "../../../components/topviews/saveCancel";
import { formattedNumber } from "./AddRemoveNumbers";
import PhoneNumberGeneral from "./PhoneNumberGeneral";
import PhoneNumberRouting from "./PhoneNumberRouting";
import PhoneNumberSMSEnable from "./PhoneNumberSMSEnable";
import PopupLoaderNew from "../PopupLoaderNew";
import PHChangeCallRoutingWarn from "./PHChangeCallRoutingWarn";
import Remove911Locations from "../locations/Remove911Location";
import { useAdminContext } from "../../../components/adminstore/Admin-Context";
import EditWarning from "../../../components/header/EditWarning";

function PhoneNumbersDetails() {
    const section1 = useRef(null);
    const section2 = useRef(null);
    const section3 = useRef(null);
    const containerRef = useRef(null);
    const navigate = useNavigate();
    const [basicActive, setBasicActive] = useState("tab1");
    const [basicActive1, setBasicActive1] = useState("tab4");
    const [basicModal, setBasicModal] = useState(false);
    const [basicModal1, setBasicModal1] = useState(false);
    const toggleShow = () => setBasicModal(!basicModal);
    const toggleShow1 = () => setBasicModal1(!basicModal1);
    const [selectVal, setSelectVal] = useState("africa");
    const [verticalActive, setVerticalActive] = useState("tab1");
    const location = useLocation();
    const [pNumInfo, setPNumInfo] = useState(
        location.state ? location.state : {}
    );
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [AddNumbers, setAddNumbers] = useState(false);
    const toggleShow12 = () => setAddNumbers(!AddNumbers);
    const [isloading, setIsloading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [rerender, setRerender] = useState(false);
    const [phonenum, setphonenum] = useState("");
    const [aliasName, setaliasName] = useState("");
    const [callRouting, setCallRouting] = useState("");
    const [warning, setwarning] = useState(false);
    const toggleWarning = () => setwarning(!warning);
    const [nineoneonewarning, setnineoneonewarning] = useState(false);
    const toggle911Warning = () => setnineoneonewarning(!nineoneonewarning);
    const [warningMessage, setwarningMessage] = useState("")
    const warningRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);
    const [finalData, setfinalData] = useState({})
    const [nineoolocation, setnineoolocation] = useState([]);
    const [smsMessage, setsmsMessage] = useState("")
    const { isEdited, setEdited } = useAdminContext();
    const [targetView, setTargetView] = useState("");
    const [showWarning, setShowWarning] = useState(false);
    const [isSmsEnabled,setIsSmsEnabled] = useState(false)
    const warningToggle = () => setShowWarning(!showWarning);
    const { register, setValue, getValues, watch, formState: { isDirty, dirtyFields, errors }, handleSubmit, reset, clearErrors, setError } = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
        defaultValues: {
            general: {
                alias_name: "",
                billing_grp: 1,
                location_id: 45,


            },
            call_routing: {},
            is_sms: false,

        }
    });

    function handleClick() {
        warningRef.current.click();
    }

    const handleOk = () => {
        setEdited(false);
        reset();
        if (targetView.indexOf("/") !== -1) {
            const targetValues = targetView.split("#")
            if (targetValues.length > 1) {
                navigate(targetValues[0],
                    {
                        state: { tab: targetValues[1] },
                    }
                );

            } else {
                navigate(targetView);
            }
        }
        setShowWarning(false);
    };


    const handleVerticalClick = (value) => {
        if (value === verticalActive) {
            return;
        }

        setVerticalActive(value);
    };
    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }
        setBasicActive(value);
    };

    const handleBasicClick1 = (value) => {
        if (value === basicActive1) {
            return;
        }
        setBasicActive1(value);
    };

    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);

    function closeSave(e) {
        reset();
    }

    const isSave =
        Object.keys(dirtyFields).length === 0 ? false : true;

    useEffect(() => {
        setEdited(isSave);
    }, [isSave]);


    const onSubmit = async (data) => {
        const modifiedData = {};
        for (const field of Object.keys(dirtyFields)) {
            // Check if the field is dirty and exists in the data object
            if (dirtyFields[field] && data.hasOwnProperty(field)) {
                // If the field is an object, extract modified subfields
                if (typeof data[field] === "object" && !Array.isArray(data[field])) {
                    modifiedData[field] = {};

                    for (const subfield of Object.keys(dirtyFields[field])) {
                        if (data[field].hasOwnProperty(subfield)) {
                            modifiedData[field][subfield] = data[field][subfield];
                        }
                    }
                } else {
                    modifiedData[field] = data[field];
                }
            }
        }
        if (modifiedData) {
            modifiedData.reqid = 74;
            modifiedData.siteid = JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid;
            modifiedData.phone_number = pNumInfo.phnumber;
            // modifiedData.logined_user = JSON.parse(
            //   sessionStorage.getItem("admin_session")
            // ).logined_user;
            console.log("modified data for phone edit :::" + JSON.stringify(modifiedData));
            console.log(JSON.stringify(modifiedData));
            setIsloading(true);
            let saverep = await editPhoneNumberDetails(modifiedData, "");
            console.log(`reponse of phone edit :::: ${JSON.stringify(saverep)}`);
            let saverepeMsg = await saverep.json();
            console.log(
                "response of modified data :::" + JSON.stringify(saverepeMsg)
            );
            setTimeout(() => {
                setIsloading(false);
            }, 1000);
            if (saverepeMsg.status && saverepeMsg.status == "success") {
                if (saverepeMsg.display_info) {
                    setfinalData(modifiedData)
                    if (saverepeMsg.module_type) {
                        setnineoolocation(saverepeMsg.nineoo_loc_list);
                        toggle911Warning();




                    } else {

                        setwarningMessage(saverepeMsg.display_info);
                        toggleWarning();
                    }

                } else {
                    setRerender(true);
                    setSuccessMessage(saverepeMsg.message);
                }
            } else {
                if (saverepeMsg.message?.errors) {
                    saverepeMsg.message.errors.forEach((err) => {

                        setError(err.param_name, {
                            type: "server",
                            message: err.message,
                        });
                        const fieldElement = document.querySelector(
                            `input[name="${err.param_name}"]`
                        );
                        if (fieldElement) {
                            fieldElement.focus();
                            fieldElement.scrollIntoView({ behavior: "smooth" });
                        }
                    });
                }
            }
        }

    }

    useEffect(() => {
        if (pNumInfo.phnumber || rerender) {
            getSpecificPhoneNumber();
            setRerender(false);
        }

    }, [pNumInfo.phnumber, rerender]);

    async function getSpecificPhoneNumber() {
        try {
            setIsloading(true);
            const response = await getSpecificPhoneDetails(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                pNumInfo.phnumber
            );
            setTimeout(() => {
                setIsloading(false);
            }, 1000);
            const phoneDetails = await response.json();
            console.log("getSpecific phoneDetails ::: " + JSON.stringify(phoneDetails));
            setaliasName(phoneDetails?.general?.alias_name ?? "");
            setphonenum(formattedNumber(pNumInfo.phnumber));
            console.log("value of call routing ::::::::::: " + (phoneDetails?.ph_details?.call_routing?.caller_id ?? ""));
            setCallRouting(phoneDetails?.ph_details?.call_routing?.caller_id ?? {})
            setsmsMessage(phoneDetails?.ph_details?.sms_enable_req_msg ?? "")
            setIsSmsEnabled(phoneDetails?.is_sms_enabled);
            const phonedetails = {
                general: {
                    alias_name: phoneDetails?.ph_details?.general?.alias_name ?? "",
                    billing_grp: phoneDetails?.ph_details?.general?.billing_grp ?? 1,
                    location_id: phoneDetails?.ph_details?.general?.location_id ?? 45,


                },
                call_routing: {},
                is_sms: phoneDetails?.ph_details?.is_sms ?? false,

            }
            reset(phonedetails);

            setRerender(false);

        } catch (error) {

        }
    }

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const scrollspyLinks = document.querySelectorAll('.nav-link');
            const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
            const stickyParent = lastLink.closest('.sticky-top');
            if (stickyParent && lastLink.classList.contains('active')) {
                lastLink.classList.remove('active');
                for (let i = 0; i < scrollspyLinks.length; i++) {
                    const firstLink = scrollspyLinks[i];
                    const parent = firstLink.closest('.sticky-top');
                    if (parent) {
                        firstLink.classList.add('active');
                        break;
                    }
                }
            }
        }, 100);
        return () => clearTimeout(timeoutId);
    }, []);

    return (
        <React.Fragment>
            <>
                <MainLinks active={2} />
                <Body
                    tablinks={2}
                    sublink={36}
                    content={
                        <>
                            <section>
                                <div className="card card-height">
                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0 ">
                                            <MDBBreadcrumb>
                                                <MDBBreadcrumbItem>
                                                    <a
                                                        onClick={(e) => {
                                                            if (isEdited) {
                                                                setTargetView("/phonenumbers");
                                                                setShowWarning(true);
                                                                return;
                                                            }
                                                            navigate("/phonenumbers");
                                                        }} >
                                                        <strong>{t("phoneSystem")}</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem active>
                                                    <a onClick={(e) => {
                                                        if (isEdited) {
                                                            if (pNumInfo.unassigned) {
                                                                setTargetView("/PhoneNumbers#tab2");
                                                                setShowWarning(true);
                                                                return;
                                                            } else {
                                                                setTargetView("/PhoneNumbers#tab1");
                                                                setShowWarning(true);
                                                                return;
                                                            }
                                                        } else {
                                                            if (pNumInfo.unassigned) {
                                                                navigate("/PhoneNumbers", {
                                                                    state: { tab: "tab2" },
                                                                });
                                                            } else {
                                                                navigate("/PhoneNumbers", {
                                                                    state: { tab: "tab1" },
                                                                });

                                                            }
                                                        }
                                                    }}>
                                                        {pNumInfo.unassigned ? (
                                                            <strong>{t("Unassigned")}</strong>

                                                        ) : (
                                                            <strong>{t("Assigned")}</strong>
                                                        )}

                                                    </a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem >
                                                    <a href="">
                                                        <strong>{phonenum}</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                            </MDBBreadcrumb>
                                        </h5>
                                        <h5 className="mb-0 mt-3 ">
                                            {phonenum}
                                        </h5>
                                        <p className="text-secondary">{aliasName}</p>
                                    </div>
                                    <div className="card-body px-0">


                                        <MDBTabs>
                                            <MDBTabsItem>
                                                <MDBTabsLink
                                                    onClick={() => handleBasicClick("tab1")}
                                                    active={basicActive === "tab1"}
                                                >
                                                    {t("settings")}
                                                </MDBTabsLink>
                                            </MDBTabsItem>

                                        </MDBTabs>

                                        <MDBTabsContent>
                                            <MDBTabsPane open={basicActive === "tab1"}>
                                                {/* Tab 1 content */}
                                                <MDBRow>
                                                    <MDBCol
                                                        size="2"
                                                        md="2"
                                                        lg="2"
                                                        sm="12"
                                                        className="col-sm-100 pr-0 leftTabs"
                                                    >


                                                        <MDBScrollspy container={containerRef}>
                                                            <MDBScrollspyLink targetRef={section1}>{t("general")}</MDBScrollspyLink>
                                                            <MDBScrollspyLink targetRef={section2}>{t("callRouting")}</MDBScrollspyLink>
                                                           { isSmsEnabled && (<MDBScrollspyLink targetRef={section3}>{t("SMSEnable")}</MDBScrollspyLink>) }
                                                        </MDBScrollspy>
                                                    </MDBCol>
                                                    <MDBCol
                                                        size="12"
                                                        md="10"
                                                        sm="12"
                                                        pr-0
                                                        className="col-sm-100 pr-0 leftTabContent"
                                                    >

                                                        <div className="vtabHeight pr-5">
                                                            <div id='element' ref={containerRef} className='scrollspy-example'>

                                                                <section ref={section1} id='section-1'>
                                                                    <PhoneNumberGeneral
                                                                        register={register}
                                                                        watch={watch}
                                                                        errors={errors}
                                                                        setValue={setValue}
                                                                    />
                                                                </section>
                                                                <section ref={section2} id='section-2'>
                                                                    <PhoneNumberRouting
                                                                        register={register}
                                                                        watch={watch}
                                                                        errors={errors}
                                                                        setValue={setValue}
                                                                        callRouting={callRouting}
                                                                        pNumInfo = {pNumInfo}
                                                                    />

                                                                </section>
                                                          {isSmsEnabled && (      <section ref={section3} id='section-3'>
                                                                    <PhoneNumberSMSEnable
                                                                        register={register}
                                                                        watch={watch}
                                                                        errors={errors}
                                                                        smsMessage={smsMessage}
                                                                    />
                                                                </section> )}
                                                            </div>
                                                            {isSave && (
                                                                <SaveChanges
                                                                    onClose={closeSave}
                                                                    isdirtyFields={isSave}
                                                                    onSave={(e) => {
                                                                        e.preventDefault();
                                                                        handleSubmit(onSubmit)();
                                                                    }}
                                                                />
                                                            )}


                                                        </div>


                                                    </MDBCol>
                                                </MDBRow>
                                            </MDBTabsPane>


                                        </MDBTabsContent>
                                    </div>
                                </div>
                            </section>
                            {isloading && (
                                <>
                                    <div className="loadingclass">
                                        <MDBBtn disabled>
                                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                            Loading...
                                        </MDBBtn>
                                    </div>
                                </>
                            )}
                            {successMessage && (
                                <MDBAlert
                                    open
                                    className="alert-center"
                                    color="success"
                                    autohide
                                    position="bottom-right"
                                    delay={10000}
                                >
                                    <i className="fas fa-check-circle me-3"></i>
                                    <span className="alert-msg">{successMessage}</span>
                                </MDBAlert>
                            )}

                        </>
                    }
                />
                {warning && (
                    <PopupLoaderNew
                        title={"Alert"}
                        content={
                            <PHChangeCallRoutingWarn
                                // phoneNum={selectedPHNum}
                                onClose={toggleWarning}
                                finalData={finalData}
                                setRerender={setRerender}
                                setSuccessMessage={setSuccessMessage}
                                warningMessage={warningMessage}
                                ref={warningRef}
                                setIsloading={setisLoading}
                            />}
                        onShow={setwarning}
                        onClose={toggleWarning}
                        onSave={handleClick}
                        isloading={isLoading}
                        flag={10}
                    />
                )}

                {nineoneonewarning && (
                    <PopupLoaderNew
                        title={"Alert"}
                        content={
                            <Remove911Locations
                                onClose={nineoneonewarning}
                                ref={warningRef}
                                setIsloading={setisLoading}
                                setRerender={setRerender}
                                setSuccessMessage={setSuccessMessage}
                                remove911LocationInfo={finalData}
                                nineoolocation={nineoolocation}
                            />
                        }
                        className={""}
                        onShow={setnineoneonewarning}
                        onClose={toggle911Warning}
                        onSave={handleClick}
                        isloading={isLoading}
                        flag={10}
                    />
                )
                }
                {showWarning && (
                    <EditWarning
                        warningToggle={warningToggle}
                        setShowWarning={setShowWarning}
                        onOk={handleOk}
                    />
                )}
            </>
        </React.Fragment>
    );


}
export default PhoneNumbersDetails;
